"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCoreUnfollowSlice = exports.postCoreFollowSlice = void 0;
const actions_1 = require("./_idMap/actions.js");
const xuder_1 = require("@sonar-software/xuder");
const followers_1 = require("../../api/followers/index.js");
exports.postCoreFollowSlice = (0, xuder_1.createPostAsyncSlice)({
    httpSagaOptions: {
        preRequestActionCreators: [(data) => (0, actions_1.addFollowed)(data.sonarObjectIds)]
    },
    name: 'CoreFollow',
    receive: false,
    request: true,
    requestHandler: followers_1.postFollow,
    yieldType: xuder_1.SagaYieldType.Latest
});
exports.postCoreUnfollowSlice = (0, xuder_1.createPostAsyncSlice)({
    httpSagaOptions: {
        preRequestActionCreators: [(data) => (0, actions_1.removeFollowed)(data.sonarObjectIds)]
    },
    name: 'CoreUnfollow',
    receive: false,
    request: true,
    requestHandler: followers_1.postUnfollow,
    yieldType: xuder_1.SagaYieldType.Latest
});
//# sourceMappingURL=post.js.map